import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {delay, map, retryWhen} from 'rxjs/operators';

@Injectable()
export class BlobRendererViewerService {
    constructor(private httpClient: HttpClient) {

    }

    public get(url: string): Observable<Blob> {
        return this.httpClient.get(url, {
            responseType: 'blob'
        }).pipe(map((blob) => {
            return blob;
        }), retryWhen(error => {
            return error.pipe(delay(2000));
        }));
    }
}
